import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { FixedBodyDiv, TitleSpan } from "../team/view-team";
import { SETTINGS_BODY_DIV } from "../../../../assets/styles/classes-constants";
import { LittleSubHeadline, LittleText, MediumText, NotificationText } from "../../../../components/typography";
import { useStructureStore } from "../../../../assets/store/useStructureStore";
import { ObjectsEnum } from "../../../../assets/utils/enums/basket";
import { StructureItem, StructureItems, StructureSection } from "./main";
import addIcon from '../../../../assets/images/icons/plus-dark-icon.svg';
import { StructureObjectField } from "../../../../assets/utils/enums/structure-object";
import { StructureItemsBody } from "./update-field";
import Input from "../../../../components/ui/inputs";
import { StructureVisibleSwitch } from "../../../../components/ui/switch";
import { Button } from "../../../../components/ui/button";
import { COLORS } from "../../../../assets/utils/enums/colors";
import { toCamelCase } from "../../../../assets/utils/pluralize-elements";
import { DropdownTypeEnum } from "../../../../assets/utils/enums/table";
import { NameIdType } from "../../../../assets/utils/enums/project";

export default function AddFieldStructureTab() {
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const missingOtherItems: StructureObjectField[] = location.state?.missingItems ?? [];;
    const isOtherItems: boolean = missingOtherItems.length > 0;
    const [visibleStatus, setVisibleStatus] = useState<boolean>(isOtherItems ? false : true);
    const [isChangedField, setIsChangedField] = useState<boolean>(true);
    const [fieldLabel, setFieldLabel] = useState<string>("");
    const structure = useStructureStore(
        (s) => s.structures[id as ObjectsEnum]
    );
    const { addField, updateFieldVisibility } = useStructureStore();
    const [updateOtherField, setUpdateOtherField] = useState<NameIdType>({ name: "", id: "" });
    const [updateOtherFieldQuery, setUpdateOtherFieldQuery] = useState<string>("");

    useEffect(() => {
        if (isOtherItems) {
            setIsChangedField(!missingOtherItems.find(x => x.label === updateOtherFieldQuery));
            return;
        }
        setIsChangedField(!(fieldLabel.length !== 0));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fieldLabel, updateOtherFieldQuery])

    const handleSelect = (item: NameIdType) => {
        setUpdateOtherField(item);
        setUpdateOtherFieldQuery(item.name); // ⬅️ важливо
        setVisibleStatus(true);
    };

    const handleInputChange = (value: string) => {
        console.log(value);
        const selected = missingOtherItems.find(
            (item) => item.label === value
        );

        if (!selected) {
            setUpdateOtherFieldQuery(value);
            setUpdateOtherField({ id: "", name: "" });
            setVisibleStatus(false);
            return;
        }

        setUpdateOtherField({
            id: selected.key,
            name: selected.label,
        });
        setVisibleStatus(true);
    };

    return (
        <FixedBodyDiv
            className={`w-60 ${SETTINGS_BODY_DIV} gap-3`}
            $isPadding={true}
        >
            <TitleSpan className="pb-0">
                <div className="d-flex flex-row align-items-center gap-3">
                    <MediumText>Редагувати папки</MediumText>
                    <hr />
                    <span className="d-flex align-items-center gap-2">
                        <img src={structure.entityIcon} alt={structure.entityTitle} />
                        <MediumText>{structure.entityTitle}</MediumText>
                    </span>
                </div>
                <NotificationText>Налаштування полів вплине на структуру всіх записів у таблицях та папці. Ви можете організувати поля в групи і згорнути ті, які ви рідко використовуєте в структурі запису. Для отримання додаткової інформації щодо конструктора полів (папок), перейдіть до нашого <b className="fw-normal accent-text">Посібника Користувача.</b></NotificationText>
                <NotificationText className="accent-text">Дізнатися більше</NotificationText>
            </TitleSpan>

            <StructureSection className="gap-0">
                <TitleSpan className="pb-2">
                    <MediumText>{location.state.title}</MediumText>
                </TitleSpan>
                <StructureItems>
                    <StructureItem>
                        <img src={addIcon} alt={"add-icon"} />
                        <MediumText>{isOtherItems ? "Додати запис" : "Нове поле"}</MediumText>
                    </StructureItem>
                    <StructureItemsBody>
                        <LittleSubHeadline>{isOtherItems ? "Оберіть запис" : "Введіть назву елементу"}</LittleSubHeadline>
                        {isOtherItems ? <Input
                            attribute={DropdownTypeEnum.PROJECTS}
                            item={updateOtherField}
                            setItem={(e) => handleSelect(e as NameIdType)}
                            value={updateOtherFieldQuery}
                            setValue={(e) => handleInputChange(e.toString())}
                            errorText={""}
                            itemsNameIdArr={missingOtherItems.map((item): NameIdType => ({ id: item.key, name: item.label }))}
                            label=""
                            placeholder={missingOtherItems[0]?.label ?? "Оберіть поле"}
                        /> : <Input
                            attribute="text"
                            value={fieldLabel}
                            setValue={setFieldLabel}
                            errorText={""}
                            label=""
                            placeholder={"Нове поле"}
                        />}

                        <div className="d-flex flex-column gap-2 mt-2">
                            <LittleSubHeadline>Видимість елементу</LittleSubHeadline>
                            <span className="d-flex w-100 justify-content-between align-items-start gap-5">
                                <LittleText>Обмежити видимість поля. Ви не зможете бачити цей запис на сторінках папки <b className="accent-text fw-normal">“{structure.entityTitle}”</b></LittleText>
                                <StructureVisibleSwitch checked={visibleStatus} setChecked={setVisibleStatus}
                                />
                            </span>
                        </div>
                        <div className="w-100 d-flex gap-2 justify-content-end mt-4">
                            <Button
                                bgcolor={COLORS.gray}
                                txtcolor={COLORS.secondary1}
                                brcolor={COLORS.gray}
                                width="30%"
                                type="large"
                                brradius="24px"
                                // className="px-4 my-3 border-2"
                                onClick={() => navigate(-1)}
                            >
                                <LittleSubHeadline>Скасувати</LittleSubHeadline>
                            </Button>
                            <Button
                                bgcolor={COLORS.secondary1}
                                txtcolor={`${COLORS.white} !important`}
                                brcolor={"transparent"}
                                width="35%"
                                type="large"
                                brradius="24px"
                                disabled={isChangedField}
                                $noactive={isChangedField}
                                onClick={() => {
                                    if (isOtherItems) {
                                        updateFieldVisibility(
                                            structure.entity,
                                            updateOtherField.id,
                                            visibleStatus
                                        );
                                        navigate(-1);

                                        return;
                                    }
                                    addField(structure.entity, {
                                        key: toCamelCase(fieldLabel),
                                        label: fieldLabel,
                                        order: structure.fields.general.length + 1,
                                        icon: addIcon,
                                        visible: visibleStatus,
                                        isCreated: true
                                    })
                                    navigate(-1);
                                }}
                            >
                                <LittleSubHeadline>Додати</LittleSubHeadline>
                            </Button>
                        </div>
                    </StructureItemsBody>
                </StructureItems>
            </StructureSection>

        </FixedBodyDiv>
    )
}